import axios from 'axios';
import fileDownload from 'js-file-download';
import React from 'react';
import { getCurrentCompanyName, getTermsAndConditions } from '../../helper/PackageJsonHelper';
import { getResource } from '../../helper/ResourcesHelper';
import { sendAgreement } from '../../networking/NetworkingRegForm';
import AlertBox from '../shared/AlertBox';
import LoadingBox from '../shared/LoadingBox';
import { MyDocumentCorporate, savePdf, savePdfBuffer } from '../shared/MyDocumentCorporate';
import { MyDocumentCorporateOther } from '../shared/MyDocumentCorporateOther';
import { MyDocumentIndividual, saveIndividualPdf, saveIndividualPdfBuffer } from '../shared/MyDocumentIndividual';
import { MyDocumentIndividualOther } from '../shared/MyDocumentIndividualOther';
import SignatureBox from '../shared/SignatureBox';

const currentCompanyName = getCurrentCompanyName();

export const getPDF = async (customerType, pdfInfo) => {
    switch (customerType) {
        case 'Corporate':
            switch (getCurrentCompanyName()) {
                case 'Lighthouse': {
                    savePdf(<MyDocumentCorporateOther obj={pdfInfo} />, 'CorporateForm.pdf')
                    // saveIndividualPdf(<MyDocumentIndividual obj={pdfInfo} />, 'IndividualForm.pdf')
                    break;
                }
                default: {
                    savePdf(<MyDocumentCorporate obj={pdfInfo} />, 'CorporateForm.pdf')
                    break;
                }
            }
            break;
        case 'Individual': {
            switch (getCurrentCompanyName()) {
                case 'Lighthouse': {
                    saveIndividualPdf(<MyDocumentIndividualOther obj={pdfInfo} />, 'IndividualForm.pdf')
                    // saveIndividualPdf(<MyDocumentIndividual obj={pdfInfo} />, 'IndividualForm.pdf')
                    break;
                }
                default: {
                    saveIndividualPdf(<MyDocumentIndividual obj={pdfInfo} />, 'IndividualForm.pdf')
                    break;
                }
            }
            break;
        }
        default:
            break;
    }
}

export default class CustomerAgreement extends React.Component {
    state = {
        customerAgreement: false,
        documents: {
            accountFile: '',
            accountFileName: '',
            isComplete: false,
            customerAgreement: false,
        },
        TaskList: [],
        readOnly: false,
        showDeleteAlert: false,
        //
        showAttachmentsDialog: false,
        rowClick: false,
        signatureClick: false,
        signatureResponse: false,
        loading: false,
    }
    componentDidUpdate(prevProps) {
        if (prevProps.objCustomerAgreement !== this.props.objCustomerAgreement && this.props.objCustomerAgreement != null) {
            this.setState({
                customerAgreement: this.props.objCustomerAgreement.customerAgreement,
                TaskList: this.props.objCustomerAgreement.TaskList,
                signatureResponse: this.props.objCustomerAgreement.signatureResponse,
                documents: { ...this.state.documents, customerAgreement: this.props.objCustomerAgreement.customerAgreement }
            }, () => {
                if (this.state.TaskList.length > 0) {
                    this.state.TaskList.forEach(value => {
                        if (value.Title === 'Original signed agreement') {
                            this.setState({
                                customerAgreement: this.props.objCustomerAgreement.customerAgreement,
                                documents: {
                                    ...this.state.documents,
                                    accountFile: value.Files[0].content,
                                    accountFileName: value.Files[0].filename,
                                    isComplete: true,
                                    customerAgreement: this.props.objCustomerAgreement.customerAgreement
                                }
                            }, () => {
                                this.props.CustomerAgreement(this.state.documents);
                            });
                        }
                    });
                } this.props.CustomerAgreement(this.state.documents);
            });
        }
        if (prevProps.readOnly !== this.props.readOnly && this.props.readOnly != null) {
            this.setState({ readOnly: this.props.readOnly })
        }
    }
    handleChangeUtilityBillFile = async (event) => {
        if (event.target.files.length > 0) {
            const file = event.target.files[0];
            const base64 = await this.readFileAsBase64(file);
            const fileContent = base64.replace(/^data:.+;base64,/, '');
            const newDocuments = {
                ...this.state.documents,
                accountFile: fileContent,
                accountFileName: file.name,
                isComplete: true,
                customerAgreement: this.state.customerAgreement
            };
            this.setState({ documents: newDocuments, readOnly: false, fromUpload: true });
            this.props.CustomerAgreement(newDocuments);
        } else {
            const newDocuments = {
                ...this.state.documents,
                accountFile: '',
                accountFileName: '',
                isComplete: false,
                customerAgreement: this.state.customerAgreement
            };
            this.setState({ documents: newDocuments, readOnly: this.props.readOnly ? true : false });
            this.props.CustomerAgreement(newDocuments);
        }
    }

    readFileAsBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event) => {
                resolve(event.target.result);
            };
            reader.onerror = (err) => {
                reject(err);
            };
            reader.readAsDataURL(file);
        });
    }

    getPDF = async () => {
        
    }

    getPDFBuffer = async () => {
        this.setState({ loading: true });
        let TaskList = this.state.TaskList;
        switch (this.props.type) {
            case 'Corporate': {
                TaskList.forEach((value, index) => {
                    if (value.Title === 'Original signed agreement') {
                        TaskList.splice(index, 1);
                        this.setState({
                            TaskList,
                            showDeleteAlert: false,
                            documents: { ...this.state.documents, isComplete: false, customerAgreement: this.state.customerAgreement }
                        });
                    }
                });

                var file = 'CorporateForm.pdf';
                let url = '';
                if (getCurrentCompanyName() === 'Lighthouse') {
                    url = await savePdfBuffer(<MyDocumentCorporateOther obj={this.props.allObjts} />);
                } else {
                    url = await savePdfBuffer(<MyDocumentCorporate obj={this.props.allObjts} />);
                }
                var base64 = await this.readFileAsBase64(url);
                var fileContent = base64.replace(/^data:.+;base64,/, '');
                var newDocuments = {
                    ...this.state.documents,
                    accountFile: fileContent,
                    accountFileName: file,
                    isComplete: true,
                    customerAgreement: this.state.customerAgreement
                };
                this.setState({ documents: newDocuments, readOnly: false, fromUpload: false });
                this.props.CustomerAgreement(newDocuments);
                break;
            }
            case 'Individual': {
                TaskList.forEach((value, index) => {
                    if (value.Title === 'Original signed agreement') {
                        TaskList.splice(index, 1);
                        this.setState({
                            TaskList,
                            showDeleteAlert: false,
                            documents: { ...this.state.documents, isComplete: false, customerAgreement: this.state.customerAgreement }
                        });
                    }
                });

                var file = 'IndividualForm.pdf';
                let url = '';
                if (getCurrentCompanyName() === 'Lighthouse') {
                    url = await saveIndividualPdfBuffer(<MyDocumentIndividualOther obj={this.props.allObjts} />);
                } else {
                    url = await saveIndividualPdfBuffer(<MyDocumentIndividual obj={this.props.allObjts} />);
                }
                var base64 = await this.readFileAsBase64(url);
                var fileContent = base64.replace(/^data:.+;base64,/, '');
                var newDocuments = {
                    ...this.state.documents,
                    accountFile: fileContent,
                    accountFileName: file,
                    isComplete: true,
                    customerAgreement: this.state.customerAgreement
                };
                this.setState({ documents: newDocuments, readOnly: false, fromUpload: false });
                this.props.CustomerAgreement(newDocuments);
                break;
            }
            default:
                break;
        }
        this.setState({ loading: false });
    }
    getTCPDF = (filename) => {
        const url = getTermsAndConditions();
        if (getCurrentCompanyName() === 'Lighthouse') {
            window.open(url, '_blank');
        } else {
            axios.get(url, {
                responseType: 'blob',
            }).then((res) => {
                fileDownload(res.data, filename);
            })
        }
    }
    handleUpdateCheck = (event) => {
        this.setState({
            customerAgreement: event.target.checked,
            documents: { ...this.state.documents, customerAgreement: event.target.checked }
        }, () => { this.props.CustomerAgreement(this.state.documents); });
    }
    SubmitPersonalRegistration = async () => {
        this.setState({ signatureClick: true });
        // this.props.submit360();
    }
    CancelPersonalRegistration = async () => {
        this.props.navigate('/');
    }
    deleteAttachmentClick(obj) {
        this.setState({ showDeleteAlert: true, readyToDeleteAttachment: obj });
    }

    closeDeleteAlert() {
        this.setState({ showDeleteAlert: false, readyToDeleteAttachment: {} });
    }

    openDeleteAlert() {
        this.setState({ showDeleteAlert: true });
    }

    yesDeleteAlert() {
        let TaskList = this.state.TaskList

        TaskList.forEach((value, index) => {
            if (value.Files[0].filename === this.state.readyToDeleteAttachment.filename) {
                TaskList.splice(index, 1);
                this.setState({
                    TaskList,
                    showDeleteAlert: false,
                    signatureResponse: false,
                    documents: {
                        ...this.state.documents, isComplete: false,
                        accountFile: null,
                        accountFileName: ''
                        , customerAgreement: this.state.customerAgreement
                    }
                }, () => {
                    this.props.CustomerAgreement(this.state.documents);
                });
            }
        })
    }
    //RowClickTable
    handleRowClick = () => {
        this.setState({ showAttachmentsDialog: true, rowClick: true })
    }
    showAttachmentsDialog = () => {
        this.setState({ showAttachmentsDialog: false })
    }
    changeState = () => {
        this.setState({ rowClick: false })
    }
    SignatureClick = () => {
        this.setState({ signatureClick: true })
    }
    CloseSignature = () => {
        this.setState({ signatureClick: false })
    }
    AddSignature = (response) => {
        /*{Description:'Include Signature', Value: Yes/No} */
        let model = [{ Description: 'Include Signature', Value: response }]
        this.props.addProps_CustomerAgreement(model);
        this.setState({ signatureResponse: response !== 'Yes' ? false : true })
        this.getPDFBuffer();
        if (response === 'Yes') {
            this.props.submit360();
        }
    }
    viewTerms = () => {
        /*
            const file = new Blob([ this.props.TermsPDF ], { type: 'pdf' });
            const element = document.createElement('a');
            element.href = URL.createObjectURL(file);
            element.download = 'Terms & Conditions.pdf';
            document.body.appendChild(element);
            element.click();
        */
        var win = window.open(this.props.TermsPDF, '_blank');
        win.focus();
    }

    SendAgreement = () => {
        if (this.state.documents != null && this.state.documents.accountFileName != '') {
            this.setState({ loading: true });
            var fileName = this.state.documents.accountFileName;
            if (fileName.indexOf('.pdf') == -1) {
                fileName = fileName + '.pdf';
            }
            let model = {
                CustomerID: parseInt(sessionStorage.getItem('ActualCustomerID')),
                Email: sessionStorage.getItem('ActualCustomerEmail'),
                fileContent: this.state.documents.accountFile,
                Filename: fileName
            }
            sendAgreement(model).then(json => {
                if (json.ErrorMessage == null || json.ErrorMessage == '') {
                    this.setState({ loading: false, showAlert: true, alertTitle: 'Success', alertMessage: getResource('Message_EmailSent') });
                }
                else {
                    this.setState({ loading: false, showAlert: true, alertTitle: 'Error', alertMessage: getResource('Message_ErrorMail') });

                }
            });
        }
    }

    closeAlert = () => {
        this.setState({ showAlert: false });
    }

    render() {
        let front = '';
        let missingDirector = true;
        let missingOwner = true;
        if (this.state.TaskList.length > 0) {
            this.state.TaskList.forEach(value => {
                if (value.Title === 'Original signed agreement') {
                    front = value.Files;
                }
            });
        }
        // Disable Digital Signature button if Director or Owner are missing and show error message
        // Any Account User checked the director role = director is not missing
        // Any Account User checked the owner role = owner is not missing
        // Any Director checked the owner role = owner is not missing
        // Every Account User didn't check the director role -> check if the director section has been filled -> filled? = director is not missing
        // Every Account User didn't check the owner role -> check if the owner section has been filled -> filled? = owner is not missing
        let directorRoleChecked = false;
        let ownerRoleChecked = false;
        let directorFilled = false;
        let ownerFilled = false;
        let ownerRoleFromDirectorChecked = false;
        let accountUserFilled = [1,2,3,4,5].some((i) => (this.props.allObjts != null && this.props.allObjts.Accountprimarycontact && this.props.allObjts.Accountprimarycontact['FirstName0' + i] != null && this.props.allObjts.Accountprimarycontact['FirstName0' + i] !== ""));
        if (this.props.allObjts.Accountprimarycontact != null) {
            directorRoleChecked = accountUserFilled && [1,2,3,4,5].some((i) => this.props.allObjts.Accountprimarycontact['Roles0' + i].includes('Director'));
            ownerRoleChecked = accountUserFilled && [1,2,3,4,5].some((i) => this.props.allObjts.Accountprimarycontact['Roles0' + i].includes('UBO'));
        }
        directorFilled = [1,2,3,4,5].some((i) => (this.props.allObjts != null && this.props.allObjts.DirectorAndAppointedOfficer && this.props.allObjts.DirectorAndAppointedOfficer['FirstName0' + i] != null && this.props.allObjts.DirectorAndAppointedOfficer['FirstName0' + i] !== ""));
        ownerFilled = [1,2,3,4,5].some((i) => (this.props.allObjts != null && this.props.allObjts.Owners && this.props.allObjts.Owners['FirstName0' + i] != null && this.props.allObjts.Owners['FirstName0' + i] !== ""));
        ownerRoleFromDirectorChecked = directorFilled && [1,2,3,4,5].some((i) => (this.props.allObjts != null && this.props.allObjts.DirectorAndAppointedOfficer && this.props.allObjts.DirectorAndAppointedOfficer['Roles0' + i].includes('UBO')));

        return (
            <div className="row" id="customer_agreement">
                <div className="col-sm-12 col-xs-12">
                    <div className="row">
                        <div className="col-md-12">
                            {/* <h5>{getResource('Customer_Paragraph')}</h5> */}

                            {/* <div className="row">
                                <div className="col-sm-6 col-xs-12">
                                    <button type="button" id="btn-signeture-alert" style={{ width: '290px' }} disabled={(missingDirector || missingOwner) || this.state.signatureResponse} className="btn btn-primary" onClick={this.SignatureClick}>
                                        {getResource('Button_DigitalSignature')}
                                    </button>
                                </div>
                                <div className="col-sm-6 col-xs-12">
                                    {currentCompanyName !== 'Khyber' && <button type="button" id="btn-generate-pdf" style={{ width: '290px' }} disabled={this.state.documents == null || this.state.documents.accountFileName === ''} className="btn btn-primary" onClick={() => getPDF(this.props.type, this.props.allObjts)}>
                                        {getResource('Button_Download')}
                                    </button>}
                                </div>
                            </div> */}

                            <div className="row">
                                {/* <div className="col-sm-6 col-xs-12">
                                    <button type="button" id="btn-sendAgreement" style={{ width: '290px' }} disabled={this.state.documents == null || this.state.documents.accountFileName === ''} className="btn btn-primary" onClick={this.SendAgreement}>
                                        {getResource('Button_SendAgreement')}
                                    </button>
                                </div> */}
                                <div className="col-sm-6 col-xs-12">
                                    {currentCompanyName !== 'Khyber' && <button type="button" id="btn-generate-tc-pdf" className="btn btn-primary" style={{ width: '290px' }}
                                        onClick={() => this.getTCPDF('Terms and conditions.pdf')}>{/*this.viewTerms}>*/}
                                        {getResource('Button_TC_Download')}
                                    </button>}
                                </div>
                            </div>

                            {/* <div className="row uk-margin">
                                <div className="col-md-12">
                                    <div className="over-hidden"> */}
                                        {
                                            // front === '' && this.state.fromUpload &&
                                            // <input type="file"
                                            //     name="document_form" id="document_form"
                                            //     onChange={this.handleChangeUtilityBillFile}
                                            //     data-rule-required="true"
                                            //     data-msg-required="Attachment required"
                                            //     data-accept-size="512000"
                                            //     data-accept-size-message="Maximum 500 kb"
                                            //     data-accept-file-types="jpg|jpeg|png|gif|xls|xlsx|pps|ppt|pptx|doc|docx|pdf"
                                            //     data-wrong-file-types-message="Only Images, PDF or Office Document is allowed"
                                            // />
                                        }
                                        {/* {
                                            front === '' && !this.state.fromUpload && this.state.documents.accountFileName != null &&
                                            <label htmlFor="" className='' onClick={() => getPDF(this.props.type, this.props.allObjts)} style={{ cursor: 'pointer' }}>
                                                {this.state.documents.accountFileName}
                                            </label>
                                        }
                                        {
                                            front !== '' &&
                                            <NewDynamicTable key="personal_identification1"
                                                hiddenHeaders={['description', 'AttachmentId', 'content']}
                                                data={front}
                                                enableClick={true}
                                                clickFunction={this.handleRowClick}
                                                newSearch={false}
                                                useDeleteButton={true}
                                                deleteFunction={this.deleteAttachmentClick.bind(this)}
                                                enableSortByHeader={false}
                                                usePaginator={false}
                                                useFilter={false}
                                            />
                                        }
                                        {
                                            front !== '' &&
                                            <AttachmentsDialog
                                                open={this.state.showAttachmentsDialog}
                                                onClose={this.showAttachmentsDialog}
                                                attachmentId={front[0].AttachmentId}
                                                file={front[0]}
                                                rowClick={this.state.rowClick}
                                                changeState={this.changeState}
                                            />
                                        } */}
                                        {/* <label htmlFor="document_form" className='small'>{getResource('Customer_Attachment')}</label> */}
                                    {/* </div>
                                </div>
                            </div> */}

                            <div className="row">
                                <div className="col-md-12">
                                    {/* <label className="description" htmlFor="terms">
                                        <input id="terms" name="terms"
                                            data-rule-required="true"
                                            data-msg-required="Field Required."
                                            type="checkbox"
                                            checked={this.state.customerAgreement}
                                            onClick={this.handleUpdateCheck} /> {getResource('Checkbox_Read')} *
                                        </label> */}
                                        {(!this.state.customerAgreement) && (<label className="error">
                                            {getResource('Customer_Agreement_Error')}
                                        </label>)}
                                        <label className="description" htmlFor="terms">
                                        <input id="terms" name="terms"
                                            data-rule-required="true"
                                            data-msg-required="Field Required."
                                            type="checkbox"
                                            checked={this.state.customerAgreement}
                                            onClick={this.handleUpdateCheck} />{getResource('Checkbox_Accept')} *<br />
                                            {this.props.type === 'Corporate' ? getResource('T&C_Sign_off_Corporate') : getResource('T&C_Sign_off_Individual')}
                                    </label>
                                </div>
                            </div>
                            <div id="submit-form-area">
                                <div className="row">
                                    <div className="col-md-12">
                                        {this.props.type === 'Corporate' && !(directorRoleChecked || directorFilled) && (ownerRoleChecked || ownerFilled || ownerRoleFromDirectorChecked) &&
                                            <label className="error">Please fill out at least one director before submitting your registration.</label>
                                        }
                                        {this.props.type === 'Corporate' && (directorRoleChecked || directorFilled) && !(ownerRoleChecked || ownerFilled || ownerRoleFromDirectorChecked) &&
                                            <label className="error">Please fill out at least one owner before submitting your registration.</label>
                                        }
                                        {this.props.type === 'Corporate' && !(directorRoleChecked || directorFilled) && !(ownerRoleChecked || ownerFilled || ownerRoleFromDirectorChecked) &&
                                            <label className="error">Please fill out at least one director and one owner before submitting your registration.</label>
                                        }
                                        </div>
                                    <div className="col-md-6">
                                        <button disabled={(this.props.type === 'Corporate' && (!(directorRoleChecked || directorFilled) || !(ownerRoleChecked || ownerFilled || ownerRoleFromDirectorChecked))) || !this.state.customerAgreement} type="button" id="save-form" className="btn btn-primary" onClick={this.SubmitPersonalRegistration}>{getResource('Final_Submit')}</button>
                                        &nbsp;
                                        <button type="button" id="cancel-form" className="btn btn-primary" onClick={this.CancelPersonalRegistration}>{getResource('Button_Cancel')}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> {/* .col-md-3 */}
                <AlertBox
                    open={this.state.showAlert}
                    onClose={this.closeAlert}
                    title={this.state.alertTitle}
                    message={this.state.alertMessage}
                    type="Ok"
                    okClick={this.closeAlert}
                />
                <LoadingBox key="loadingbox-customer-agreement" loading={this.state.loading} />
                <AlertBox open={this.state.showDeleteAlert} onClose={this.closeDeleteAlert.bind(this)} title="Are you sure you want to delete this file?" message="This action can not be undone." type="Yes/No" yesClick={this.yesDeleteAlert.bind(this)} noClick={this.closeDeleteAlert.bind(this)} />
                <SignatureBox open={this.state.signatureClick} close={this.CloseSignature} addSignature={this.AddSignature} sendSignature={this.SubmitPersonalRegistration} />
            </div>
        );
    }
}